import { createStyles, Theme } from "@material-ui/core";
import { borderRadius } from "react-select/src/theme";
export const userStyles = (theme: Theme) => createStyles({
dialogTitle:{
    fontWeight: 600,
    fontSize: 24,
    color: '#333'
},
listItem: {

},
checkBoxElement: {
    padding: '0px 7px',
    top: 0,
    width: 20,
    height: 20,
    '-moz-appearance': 'none',
    opacity: 1,
    color: 'rgb(204, 204, 204)',
    border: '1px solid #B2B2B2',
    borderRadius: 4,
    margin: '-4px 14px 0px 16px',
    '& svg': {
        fontSize: '1.5rem',
        fontFamily: '"Nunito", sans-serif',
        fill: '#979797',
        opacity: 0
    },
    '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
    }
},
checkedCheckbox: {
    backgroundColor: '#1d7dea!important',
    border: '1px solid #1d7dea !important',
    borderRadius: 2,
    color: '#99a1a7',
    '&::before': {
        content: "''",
        fontSize: 14,
        position: 'absolute',
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: 'solid #fff',
        borderWidth: '0 2px 2px 0',
        transform: 'rotate(45deg)'
    },
    '&:hover': {
        backgroundColor: '#1d7dea'
    }
},
primaryColor: {
    color: 'rgb(29 125 234)'
},
checkboxLabel: {
    fontSize: 14,
    color: '#333',
    fontWeight: 600,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 214,
    overflow: 'hidden'
},
dialogContainer: {
 width: 525,
 marginBottom: '-24px',
 '& .leftBox': {
    width: 245,
    margin: '-20px -24px',    
    overflow: 'auto',
    '&>:first-child': {
        height: 320,
        '& .ps__rail-y': {
            right: -4,
            width: 12
        },
        '& .ps__rail-x': {
            display: 'none'
        }
    }     
 },
 '& .listItem': {
    padding: '10px 10px 10px 24px',   
    marginBottom: 2,
    '&:hover': {
        cursor: 'pointer',
        background: '#1d7dea',
        color: '#fff',
        '& p': {
            color: '#fff'
        }
    }
},
 
},

activeLink: {
    background: '#1d7dea',
    color: '#fff',
    '& p': {
        color: '#fff'
    }
},

rightBox: {
    width: 327,
    margin: '-20px -24px 0px 0px',
    height: 320,
    paddingLeft: '30px',
    overflow: 'auto',
    background: 'rgb(229 229 229)',
    '&>:first-child': {
        height: 320,
        '& .ps__rail-y': {
            right: -4,
            width: 12
        },
        '& .ps__rail-x': {
            display: 'none'
        }
    },
    '& .searchBar': {
        padding: '16px 12px',
        '&>:first-child': {
            width: 'auto',
            '&>:nth-child(1)': {
                width: 260,
                background: 'rgb(0 0 0 / 0%)',
                marginLeft: -9,
                borderRadius: 0
            }
        }
    },
    '& .list': {
        background: '#E5E5E5',
        height: '48px',
        padding: 6
    }
 },
marginBottomSM: {
    marginBottom: 6,
    marginTop: 6
},
});